export const NavList = [
    {
        icon: "",
        label: "Dashboard",
        location: "/",
        key: "dashboard",
    },
]
